import styled from 'styled-components';

export const LoginLabel = styled.label`
    z-index: 3;
    color: #fff;
    align-self: flex-start;
    position: relative;
    left: 12px;
    margin-bottom: 10px;
`;

export const LoginInputBusiness = styled.input`
    z-index: 3;
    background: #fff;
    border: ${(prop) => prop.isBusiness === true ? '1px solid transparent' : 'none'};
    box-shadow: ${(prop) => prop.isBusiness === true ? '0 2px 5px 1px rgb(64 60 67 / 16%);' : 'none'};
    border-radius: 24px;
    width: 90%;
    margin-bottom: ${(prop) => prop.isBusiness === true ? '15px' : '0px'};
    padding-left: 15px;
    position: relative;
    left: -12px;
    height: ${(prop) => prop.isBusiness === true ? '30px' : '0 !important'};
    transition: .3s ease-in;

    @media (max-width: 500px) {
        width: 100%;
    }
`;

export const LoginLabelBusiness = styled.label`
    z-index: 3;
    color: #fff;
    align-self: flex-start;
    position: relative;
    left: 12px;
    margin-bottom: 10px;
    font-size: ${(prop) => prop.isBusiness === true ? '16px' : '0px'};
    transition: .3s ease-in;
`;

export const ButtonWrapper = styled.div`
    width: 90%;
    margin: ${(prop) => prop.centered ? '50px auto 35px' : '5px auto 0'};
    display: flex;
    justify-content: ${(prop) => prop.centered ? 'center' : 'space-between'};
    position: relative;
    left: -12px;

    @media (max-width: 500px) {
        width: 100%;
    }
`;
